module.exports = __webpack_public_path__ + "img/step_four.b46adc94.png";